module.exports = __webpack_public_path__ + "img/nx.47ec13cf.jpg";